import { Link } from 'react-router-dom';
import { AppBar, Screen } from '@/components/layout';
import { Button, EmptyState } from '@/components/ui';

export function NotFoundPage() {
  return (
    <Screen withNav={false}>
      <AppBar title="새싹돋보기" back />
      <EmptyState
        title="찾는 화면이 없어요"
        body="주소가 바뀌었거나 아직 준비 중인 화면일 수 있어요."
        action={
          <Link to="/">
            <Button>홈으로 돌아가기</Button>
          </Link>
        }
      />
    </Screen>
  );
}
